import { DatePipe } from "@angular/common";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Component, OnInit } from "@angular/core";
import { saveAs } from "file-saver";
import { LocalStorageService, SessionStorageService } from "ngx-webstorage";
import "rxjs/Rx";
import { environment } from "src/environments/environment";
import { MyserviceService } from "../myservice.service";
import * as moment from "moment";

@Component({
    selector: "app-m-shipment",
    templateUrl: "./m-shipment.component.html",
    styleUrls: ["./m-shipment.component.css"],
})
export class MShipmentComponent implements OnInit {
    document: any = {};
    senderArray = [];
    receiverArray = [];
    selected;
    noRecords: boolean = false;
    statusArray = [];
    ackStatusArray = [];
    correlationArray = [];
    public count = 0;
    public show: boolean = false;
    public show1: boolean = false;
    searchData: any = [];
    transactionArray = [];
    dtOptions: DataTables.Settings = {};
    display: boolean;
    detailInfoData: any = {};
    tableHeaders: { field: string; header: string }[];
    userRole: string;
    dateType :any
    dateTypeList = [
        {label : 'Custom Range' ,value: 'Custom Range'},
        {label : 'Last 30 Days' ,value: 'Last 30 Days'},
        {label : 'Last 7 Days' ,value: 'Last 7 Days'},
        {label : 'Today' ,value: 'Today'},
        {label : 'Yesterday' ,value: 'Yesterday'}
    ]
    // isDateDisabled: boolean = false;
      alwaysShowCalendars: boolean;
      ranges: any = {
            'Today': [ moment().startOf('day'), moment().endOf('day') ],
            'Yesterday': [ moment().subtract(1, 'days').startOf('day'), moment().subtract(1, 'days').endOf('day')],
            'Last 7 Days': [ moment().subtract(6, 'days').startOf('day'), moment().endOf('day') ],
            'Last 30 Days': [ moment().subtract(29, 'days').startOf('day'), moment().endOf('day') ],
            'This Month': [ moment().startOf('month').startOf('day'), moment().endOf('month').endOf('day') ],
            'Last Month': [
              moment().subtract(1, 'month').startOf('month').startOf('day'),
              moment().subtract(1, 'month').endOf('month').endOf('day')      
            ]
          };
    previewTranslation: any;
    displayPreTranslation: boolean;
    filePath: any;
    
    constructor(
        private myservice: MyserviceService,
        public session: SessionStorageService,
        public localstorage: LocalStorageService,
        private http: HttpClient,
        public datepipe: DatePipe
    ) {}

    ngOnInit() {
        this.userRole = this.session.retrieve("userRole");
        this.setToDefault();
        this.transactionArray.push({ label: "856", value: "856" });

        this.tableHeaders = [
            { field: "dateTimeReceived", header: "Date Time" },
            { field: "fileId", header: "Instance Id" },
            { field: "asnNumber", header: "Shipment#" },
            { field: "direction", header: "Direction" },
            { field: "status ", header: "Status" },
            { field: "ackStatus", header: "AckStatus" },
            { field: "poNumber", header: "PoNumber" },
        ];
        this.dtOptions = {
            order: [[0, "desc"]],
        };
    }

    addFilter() {
        if (this.count == 0) {
            this.show = true;
            this.count = this.count + 1;
        } else {
            alert("Limit exceeded... cannot add more feilds");
        }
    }

    removeFilter() {
        if (this.count == 1) {
            this.show = false;
            this.count = this.count - 1;
            this.document.corrValue1 = "";
            this.document.corrAttribute1 = "-1";
        } else {
            alert("Limit exceeded... cannot remove more feilds");
        }
    }

    search(document) {
        this.searchData = [];
        this.document = document;
        this.document.flag = "search";
        if (
            this.document.corrAttribute != "-1" &&
            this.document.corrValue == ""
        ) {
            alert("Please enter Correlation Value !!");
            return false;
        }
        if (
            this.document.corrAttribute == "-1" &&
            this.document.corrValue != ""
        ) {
            alert("Please select Correlation !!");
            return false;
        }
        if (
            this.document.corrAttribute1 != "-1" &&
            this.document.corrValue1 == ""
        ) {
            alert("Please enter Correlation Value !!");
            return false;
        }
        if (
            this.document.corrAttribute1 == "-1" &&
            this.document.corrValue1 != ""
        ) {
            alert("Please select Correlation !!");
            return false;
        }

        this.document.fromDate = this.datepipe.transform(
            this.selected.startDate,
            "MM/dd/yyyy HH:mm"
        );
        this.document.toDate = this.datepipe.transform(
            this.selected.endDate,
            "MM/dd/yyyy HH:mm"
        );
        let headers = new HttpHeaders();
        headers = headers.append(
            "authorization",
            this.localstorage.retrieve("token")
        );
        this.http
            .post(environment.apiUrl + "/shipment/search", this.document, {
                headers: headers,
            })
            .subscribe((data) => {
                this.searchData = data;
                if (this.searchData.length == 0) {
                    this.noRecords = true;
                }
            });
    }

    detailInfo(asnNumber, poNumber, fileId, database) {
        this.display = true;
        let headers = new HttpHeaders();
        headers = headers.append(
            "authorization",
            this.localstorage.retrieve("token")
        );
        this.http
            .get(
                environment.apiUrl +
                    "/shipment/detailInfo/" +
                    asnNumber +
                    "/" +
                    poNumber +
                    "/" +
                    fileId +
                    "/" +
                    database,
                { headers: headers }
            )
            .subscribe((data) => {
                this.detailInfoData = data;
            });
    }

    export(document) {
        this.document = document;
        this.document.flag = "excel";
        let headers = new HttpHeaders();
        headers = headers.append(
            "authorization",
            this.localstorage.retrieve("token")
        );
        this.http
            .post(environment.apiUrl + "/shipment/download", this.document, {
                responseType: "blob",
                headers: headers,
            })
            .subscribe(
                (response: any) => {
                    var blob = new Blob([response], {
                        type: "application/vnd.ms-excel",
                    });
                    saveAs(
                        blob,
                        "ShipmentReport_" +
                            new Date().toLocaleDateString() +
                            ".xlsx"
                    );
                },
                (error) => {
                    //console.log("Error occured" + error);
                }
            );
    }

    translationFileDownload(filePath) {
        // this.myservice.translationFileDownload(filePath);
        this.myservice.translationFilePreview(filePath).subscribe((data: any) => {
             setTimeout(() => {
                this.previewTranslation = data;  
                this.displayPreTranslation = true; 
            }, 500);             
        });
        this.filePath = filePath
    }

    download(){
        this.myservice.translationFileDownload(this.filePath);
    }

    setToDefault() {
        this.noRecords = false;
        this.document.database = "LIVE";
        let today = new Date();
        this.selected = {
            startDate: new Date(
                today.getFullYear(),
                today.getMonth(),
                today.getDate(),
                0,
                0,
                0
            ),
            endDate: new Date(
                today.getFullYear(),
                today.getMonth(),
                today.getDate(),
                23,
                59,
                0
            ),
        };
        this.dbChange("M", this.document.database);
        this.statusArray = this.myservice.getStatus();
        this.ackStatusArray = this.myservice.getAckStatus();
        this.correlationArray = this.myservice.getcorrelation(
            this.localstorage.retrieve("token"),
            "856"
        );
        this.count = 0;
        this.show = false;
        this.show1 = false;
        this.document.transactionType = "856";
        this.document.senderId = "-1";
        this.document.receiverId = "-1";
        this.document.ackStatus = "-1";
        this.document.status = "-1";
        this.document.corrAttribute = "-1";
        this.document.corrAttribute1 = "-1";
        this.document.corrValue = "";
        this.document.corrValue1 = "";
        this.searchData = [];
    }

    dbChange(flowFlag, database) {
        this.senderArray = this.myservice.getSenderId(
            this.localstorage.retrieve("token"),
            flowFlag,
            database
        );

        this.receiverArray = this.myservice.getReceiverId(
            this.localstorage.retrieve("token"),
            flowFlag,
            database
        );
    }
    // dateTypeChange(type: any) {
    //     this.isDateDisabled = true;
    //     let fromDate = new Date();
    //     let toDate = new Date();
    //         switch(type) {
    //         case 'Last 30 Days':
    //             fromDate.setDate(fromDate.getDate() - 30);
    //             this.selected = {
    //                 startDate: new Date(
    //                     fromDate.getFullYear(),
    //                     fromDate.getMonth(),
    //                     fromDate.getDate(),
    //                     fromDate.getHours(),
    //                     fromDate.getMinutes(),
    //                     fromDate.getSeconds(),
    //                 ),
    //                 endDate: new Date(
    //                     toDate.getFullYear(),
    //                     toDate.getMonth(),
    //                     toDate.getDate(),
    //                     toDate.getHours(),
    //                     toDate.getMinutes(),
    //                     toDate.getSeconds(),
    //                 ),
    //             };
    //             break;
                
    //         case 'Last 7 Days':
    //             fromDate.setDate(fromDate.getDate() - 7);
    //             this.selected = {
    //                 startDate: new Date(
    //                     fromDate.getFullYear(),
    //                     fromDate.getMonth(),
    //                     fromDate.getDate(),
    //                     fromDate.getHours(),
    //                     fromDate.getMinutes(),
    //                     fromDate.getSeconds(),
    //                 ),
    //                 endDate: new Date(
    //                     toDate.getFullYear(),
    //                     toDate.getMonth(),
    //                     toDate.getDate(),
    //                     toDate.getHours(),
    //                     toDate.getMinutes(),
    //                     toDate.getSeconds(),
    //                 ),
    //             };
    //             break;
                
    //         case 'Today':
    //             this.selected = {
    //                 startDate: new Date(
    //                     fromDate.getFullYear(),
    //                     fromDate.getMonth(),
    //                     fromDate.getDate(),
    //                     0, 0, 0
    //                 ), 
    //                 endDate: new Date(
    //                     fromDate.getFullYear(),
    //                     fromDate.getMonth(),
    //                     fromDate.getDate(),
    //                     23, 59, 59
    //                 ), 
    //             };
    //             break;
    
    //         case 'Yesterday':
    //             fromDate.setDate(fromDate.getDate() - 1);
    //             this.selected = {
    //                 startDate: new Date(
    //                     fromDate.getFullYear(),
    //                     fromDate.getMonth(),
    //                     fromDate.getDate(),
    //                     0, 0, 0
    //                 ), 
    //                 endDate: new Date(
    //                     fromDate.getFullYear(),
    //                     fromDate.getMonth(),
    //                     fromDate.getDate(),
    //                     23, 59, 59
    //                 ), 
    //             };
    //             break;
    
    //         case 'Custom Range':
    //             this.isDateDisabled = false;
    //             fromDate.setDate(fromDate.getDate() - 45);
    //             this.selected = {
    //                 startDate: new Date(
    //                     fromDate.getFullYear(),
    //                     fromDate.getMonth(),
    //                     fromDate.getDate(),
    //                     fromDate.getHours(),
    //                     fromDate.getMinutes(),
    //                     fromDate.getSeconds(),
    //                 ),
    //                 endDate: new Date(
    //                     toDate.getFullYear(),
    //                     toDate.getMonth(),
    //                     toDate.getDate(),
    //                     toDate.getHours(),
    //                     toDate.getMinutes(),
    //                     toDate.getSeconds(),
    //                 ),
    //             };
    //             break;
    
    //         default:
    //             this.selected = null;
    //             break;
    //     }
    
    //     //console.log('Selected Date Range: ', this.selected);
    // }
}
